module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_3-95138c80c5e6f4ab75846d141c9745e8.jpg";